import { groups } from '@/features/DealSummary/PullCreditModal/constants'

export function getUserGroup(user) {
  if (!user?.groups?.length) return

  return groups.find((g) => g.name === user.groups[0].name)
}
